import React, {useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UploadCloud } from "lucide-react";

const InsightNoteMenuBar = ({saveNotebook, makePowerPointDocument, showSavedMessage=false}) => {
  const [showSaveTooltip, setShowSaveTooltip] = useState(false);
  return (
    <div className="note-menu-bar">
        <div 
          className='relative' 
          onMouseEnter={() => setShowSaveTooltip(true)}
          onMouseLeave={() => setShowSaveTooltip(false)}
        >
          {showSaveTooltip && 
            <div 
              className="absolute top-[45px] left-2 rounded-md text-white bg-gray-600 w-[100px] py-2 px-3 z-[9999] text-center"
              >
                保存する
              </div>}
          {showSavedMessage && 
            <div className="absolute top-[45px] left-2 rounded-md text-white bg-gray-600 w-[120px] py-2 px-3 z-[9999] text-center">
              保存しました
            </div>}
          <div className="save-icon menu-bar-icon-container" onClick={saveNotebook}><UploadCloud className="menu-bar-icon" /></div>
        </div>
        
        {/* <div className="ppt-message save-message" onClick={makePowerPointDocument}>PowerPointを作成しました</div> */}
        {/* <div className="ppt-icon-message save-message">PowerPointの作成</div> */}
        {/* <div className="ppt-icon menu-bar-icon-container"><FontAwesomeIcon icon={faFilePowerpoint} className='menu-bar-icon' /></div> */}
    </div>
  )
}

export default InsightNoteMenuBar